/**
 * JavaScript for the Endless Learning shared section
 * Handles countdown functionality for course cards loaded via HTMX
 */

/**
 * Initialize and run countdown clocks if present in the content
 * @returns {void}
 */
const runCountdown = () => {
    /** @type {HTMLElement|null} */
    const countdownClock = document.querySelector('.countdown');

    if (countdownClock) {
        import('../../modules/countdownClock.js').then(({CountdownClock}) => {
            /** @type {HTMLElement|null} */
            const clock = countdownClock.querySelector('.clock');
            const endTimestamp = Number(countdownClock.dataset.closeTimestamp);

            new CountdownClock(clock, endTimestamp, () => window.location.reload());
        });
    }
};

/**
 * Initialize Cardset Slider within the Endless Learning section
 * @returns {void}
 */
const initializeCardsetSlider = () => {
    const endlessLearningSection = document.querySelector('#endless-learning');
    if (!endlessLearningSection) {
        return;
    }
    const sliders = endlessLearningSection.querySelectorAll('[data-cardset-slider]');
    if (sliders.length > 0) {
        import('../../components/cardsetSlider.js').then(({CardsetSlider}) => {
            sliders.forEach(sliderElement => new CardsetSlider(/** @type {HTMLElement} */ (sliderElement)));
        });
    }
};

/**
 * Initialize the endless learning section
 * Sets up event listeners for HTMX content swaps
 * @returns {void}
 */
function initEndlessLearning() {
    // Listen for HTMX content swaps to initialize countdowns
    document.addEventListener('htmx:afterSwap', (event) => {
        // Check if the swap target is within the endless learning section
        const target = /** @type {CustomEvent} */ (event).detail.target;
        if (target && (target.id === 'ixdf-career-programs' || target.closest('#endless-learning'))) {
            document.dispatchEvent(new CustomEvent('lazy:initContent'));
            runCountdown();
            initializeCardsetSlider();
        }
    });

    // Run countdown on initial load if present
    runCountdown();

    // Initialize Cardset Slider on initial load
    initializeCardsetSlider();
}

// Initialize when DOM is ready
document.readyState === 'loading' 
    ? document.addEventListener('DOMContentLoaded', initEndlessLearning) 
    : initEndlessLearning();
